<div class="navbar-wrapper" [ngClass]="{'container': this.flatConfig.layout === 'horizontal' && this.flatConfig.subLayout === 'horizontal-2'}">


  <app-nav-content (onNavMobCollapse)="navMobCollapse()"></app-nav-content>
</div>

